import config from 'config/config'
import { I18n } from 'lib/i18n'
import React from 'react'
import { Button } from 'semantic-ui-react'

export default (props) => {
  const {
    id,
    saveDiscount,
    confirmationModal,
    invalid,
    handleSubmit,
    dirty,
    reset,
  } = props
  return [
    <Button
      labelPosition="right"
      content={I18n.t('global.cancel')}
      icon="cancel"
      secondary
      onClick={() => {
        confirmationModal({
          doNotDisplay: !dirty,
          icon: config.icons.delete,
          negative: true,
          title: I18n.t('global.abortModal.title'),
          text: I18n.t('global.abortModal.text'),
          button: I18n.t('global.abortModal.button'),
          confirm: () => {
            reset()
          },
        })
      }}
    />,
    <Button
      {...{
        color: 'green',
        labelPosition: 'right',
        disabled: invalid || (id && !dirty),
        icon: 'checkmark',
        content: I18n.t('global.save'),
        onClick: handleSubmit((formValues) => {
          saveDiscount({ ...formValues })
        }),
      }}
    />,
  ]
}



// WEBPACK FOOTER //
// ./src/components/admin/Discounts/getActions.js